import React from 'react';
import './freaks-promo.css';
import footerImg from '../assets/banner ticket .png';
import { useLanguage } from "../contexts/LanguageContext";

const FreaksPromo = () => {
    const { isArabic } = useLanguage();

    const translations = {
        title: isArabic 
            ? 'فريكس أوف نيتشر الحلقة السابعة: فريك يارد 5–6 و12–13 فبراير'
            : 'FREAKS OF NATURE E7: FREAK YARD 5-6 & 12- 13 FEB',
        location: isArabic ? 'بنبان، الرياض' : 'BANBAN, RIYADH',
        subtitle: isArabic 
            ? 'موسيقى، فن وثقافة في فريكيارد. تعود فريكس أوف نيتشر في الحلقة السابعة: فريكيارد'
            : 'Music, Art & Culture at Freakyard Freaks of Nature is back with Episode 7: Freakyard.',
        description: isArabic 
            ? 'المهرجان الرائد في السعودية للموسيقى الإلكترونية والفنون على مدار عطلتين متتاليتين'
            : "Saudi Arabia's premier two-weekend boutique electronic music and art festival.",
        djs: isArabic ? '+100 دي جاي' : '100+ DJS',
        stages: isArabic ? '3 مسارح عملاقة' : '3 HUGE STAGES',
        nights: isArabic ? '4 ليالٍ لا تفوت' : '4 UNMISSABLE NIGHTS',
        weekend1Label: isArabic ? 'العطلة الأولى' : 'WEEKEND 1',
        weekend1Date: isArabic ? '5–6 فبراير 2026' : '5-6 FEBRUARY 2026',
        weekend2Label: isArabic ? 'العطلة الثانية' : 'WEEKEND 2',
        weekend2Date: isArabic ? '12–13 فبراير 2026' : '12-13 FEBRUARY 2026',
        details: isArabic 
            ? 'استعدوا لرحلة فنية تجمع نخبة من أبرز الفنانين العالميين في الموسيقى الإلكترونية، من موسيقى الـ هاوس والـ تكنو والـ أفرو، بالإضافة إلى سوق طعام متنوع، ومناطق VIP مخصصة، وأعمال فنية وتجارب غامرة تتجاوز كل التوقعات.'
            : "Expect the best international electronic artists across House, Techno & Afro, delicious food market, dedicated VIP spaces, art installations and more immersive worlds than ever...we've got your inner freak covered.",
        from: isArabic ? 'ابتداءً من' : 'FROM',
        buyTickets: isArabic ? 'اشتر التذاكر' : 'BUY TICKETS'
    };

    return (
        <div className="promo-container">
            <div className="left-section">
                {/* Header Card */}
                <div className="header-card">
                    <h1 className="main-title">
                        {translations.title}
                    </h1>
                    <div className="location">
                        <svg className="location-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                            <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                        <a href="https://www.google.com/maps/place/Banban,+Riyadh,+Saudi+Arabia" target="_blank" rel="noopener noreferrer">
                            <span className="location-text">{translations.location}</span>
                        </a>
                    </div>
                </div>

                {/* Info Card */}
                <div className="info-card">
                    <p className="subtitle">
                        {translations.subtitle}
                    </p>
                    <p className="description">
                        {translations.description}
                    </p>

                    <div className="features">
                        <div className="feature-badge">{translations.djs}</div>
                        <div className="feature-badge">{translations.stages}</div>
                        <div className="feature-badge">{translations.nights}</div>
                    </div>

                    <div className="weekends">
                        <div className="weekend-card">
                            <div className="weekend-label">{translations.weekend1Label}</div>
                            <div className="weekend-date">{translations.weekend1Date}</div>
                        </div>
                        <div className="weekend-card">
                            <div className="weekend-label">{translations.weekend2Label}</div>
                            <div className="weekend-date">{translations.weekend2Date}</div>
                        </div>
                    </div>

                    <p className="details">
                        {translations.details}
                    </p>
                </div>
            </div>

            <div className="right-section">
                {/* Illustration Card */}
                <div className="illustration-card">
                    <img src={footerImg} alt="Freaks of Nature" className="illustration-image" />
                </div>

                {/* Price Card */}
                <div className="price-card">
                    <div className="price-info">
                        <div className="price-label">{translations.from}</div>
                        <div className="price-original">
                            {isArabic ? '175.00 ريال سعودي' : 'SAR 175.00'}
                        </div>
                        {/* <div className="price-current">
                            {isArabic ? '295.00 ريال سعودي' : 'SAR 295.00'}
                        </div> */}
                    </div>
                    <a
                        href="https://nofomo.com/events/freaks-of-nature-e7-freak-yard"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="buy-button"
                        onClick={() => {
                            const getUTM = () => {
                                const stored = sessionStorage.getItem('utm_params');
                                return stored ? JSON.parse(stored) : {};
                            };
                            const utm = getUTM();

                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                'event': 'action_cta_click',
                                'button_text': translations.buyTickets,
                                'class_id': 'buy-button',
                                'position': {
                                    'page': 'home',
                                    'section': 'freaks-promo',
                                    'component': 'price-card'
                                },
                                'referrer_source': document.referrer,
                                'utm_source': utm.utm_source || '',
                                'utm_medium': utm.utm_medium || '',
                                'utm_campaign': utm.utm_campaign || '',
                                'utm_term': utm.utm_term || '',
                                'utm_content': utm.utm_content || '',
                                'gclid': utm.gclid || '',
                                'fbclid': utm.fbclid || '',
                                'ttclid': utm.ttclid || ''
                            });
                        }}
                    >
                        {translations.buyTickets}
                    </a>
                </div>
            </div>
        </div>
    );
};

export default FreaksPromo;